<div class="gear">
  <nb-icon style="cursor: pointer" icon="settings" [matMenuTriggerFor]="menu"/>

  <mat-menu #menu="matMenu" xPosition="before">
    <div class="change-table">
      <div class="section-menu">

        <p i18n="@@GridSettings">
          Настройка таблицы
          <tui-icon icon="refresh-ccw" style="cursor: pointer" (click)="tableService.reset()" i18n-nbTooltip="@@SbrositNastroyki" nbTooltip="Сбросить настройки"/>
        </p>

        <div cdkDropListGroup>
          @for (column of tableService.getColumns(); track column; let i = $index) {
            <div cdkDropList [cdkDropListData]="{index:i}" (cdkDropListDropped)="drop($event)">
              <nb-checkbox size="small" class="drag" [checked]="column.enabled" [disabled]="column.readonly" (change)="setColumn(column, !column.enabled)" cdkDrag>
                {{ column.title || 'col' }}
              </nb-checkbox>
            </div>
          }
        </div>

        @if (tableService?.widgetTypes) {
          <p i18n="@@Widget">Виджет</p>
          @for (widgetType of tableService?.widgetTypes; track widgetType) {
            <nb-checkbox size="small" [checked]="isWidgetChecked(widgetType)" (checkedChange)="setWidget(widgetType, $event)">{{ widgetType.title }}</nb-checkbox>
          }
        }
      </div>
    </div>
  </mat-menu>
</div>
